<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgspu',
  components: {
    PageTable,
  },
}
</script>
